module.exports = {
    currentPage:window.location.pathname,

    currentDomain:window.location.hostname,

    currentSubdomain:window.location.hostname.split('.')[0],

    currentProtocol:window.location.protocol,

    currentPort:window.location.port,

    checkIncludes:function(array){
        return array.includes(this.currentPage.split('/')[1]);
    },

    login:function(){
        var array = [
            'login',
            'restore',
            'verify',
            'instructions',
            'password_reset',
            'register',
        ];
        return this.checkIncludes(array);
    },

    promo:function(){
        var array = [
            'promo',
            'promo/*',
            'promo/show/*',
        ];
        return this.checkIncludes(array);
    },

    testpackages:function(){
        var array = [
            'scorm',
            'testpackage',
            'education',
        ];
        return this.checkIncludes(array);
    },

    jtree:function(){
        var array = [
            'scorm',
            'testpackage',
        ];
        return this.checkIncludes(array);
    },

    home:function(){
        var array = [
            'home',
        ];
        return this.checkIncludes(array);
    },

    isKnpSnappyFileForQReports: function() {
        return this.currentPage.search(/\/tmp\/knp_snappy.*\.html/) === -1 ? false : true;
    }
}
